import { createContext, useContext, useEffect, useMemo, useRef } from "react";
import Pusher from "pusher-js";
import dotenv from "react-dotenv";
import { useAuth } from "./useAuth";

const ChatPusherContext = createContext({ onMessageSent: () => () => {} });

export const ChatPusherProvider = ({ children }) => {
  const { user } = useAuth();
  const listenersRef = useRef(new Set());
  const pusherRef = useRef(null);

  useEffect(() => {
    if (!user?.token) return;

    const pusher = new Pusher(dotenv.PUSHER_APP_KEY, {
      cluster: dotenv.PUSHER_APP_CLUSTER,
      encrypted: true,
    });
    const channel = pusher.subscribe("chat");
    channel.bind("MessageSent", (data) => {
      listenersRef.current.forEach((listener) => listener(data));
    });
    pusherRef.current = pusher;

    return () => {
      channel.unbind("MessageSent");
      pusher.unsubscribe("chat");
      pusher.disconnect();
      pusherRef.current = null;
    };
  }, [user?.token]);

  const value = useMemo(
    () => ({
      onMessageSent: (callback) => {
        listenersRef.current.add(callback);
        return () => listenersRef.current.delete(callback);
      },
    }),
    []
  );

  return (
    <ChatPusherContext.Provider value={value}>
      {children}
    </ChatPusherContext.Provider>
  );
};

export const useChatPusher = () => useContext(ChatPusherContext);
